<template>
	<svg t="1686291875779" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2820"
		xmlns:xlink="http://www.w3.org/1999/xlink" width="200" height="200">
		<path d="M136.949 121.044h764.783v764.784H136.95z" p-id="2821"></path>
	</svg>
</template>
